var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-md-12 col-lg-12" },
        [
          _c(
            "c-table",
            {
              ref: "substanceTable",
              attrs: {
                title: "구성성분 목록",
                tableId: "substanceTable",
                columns: _vm.grid.columns,
                data: _vm.grid.data,
                columnSetting: false,
                selection: "multiple",
                rowKey: "mdmChemId",
                filtering: false,
                usePaging: false,
                hideBottom: true,
                gridHeight: "400px",
                editable: _vm.editable,
                checkDisableColumn: "noFlag",
              },
              on: {
                linkClick: _vm.linkClick,
                "table-data-change": _vm.tableDataChange,
              },
              scopedSlots: _vm._u([
                {
                  key: "customArea",
                  fn: function ({ props, col }) {
                    return [
                      ["twaPpm", "twaMm", "stelPpm", "stelMm"].includes(
                        col.name
                      )
                        ? [
                            props.row.regulTwaStel > 0
                              ? _c("c-text-column", {
                                  attrs: {
                                    editable: _vm.editable,
                                    props: props,
                                    col: col,
                                  },
                                  on: {
                                    datachange: function ($event) {
                                      return _vm.datachange(props)
                                    },
                                  },
                                  model: {
                                    value: props.row[col.name],
                                    callback: function ($$v) {
                                      _vm.$set(props.row, col.name, $$v)
                                    },
                                    expression: "props.row[col.name]",
                                  },
                                })
                              : _c("span", [
                                  _vm._v(_vm._s(props.row[col.name])),
                                ]),
                          ]
                        : _vm._e(),
                      col.name === "regulationQuantityDose"
                        ? [
                            props.row.regulQuanti > 0
                              ? _c("c-text-column", {
                                  attrs: {
                                    editable: _vm.editable,
                                    props: props,
                                    col: col,
                                  },
                                  on: {
                                    datachange: function ($event) {
                                      return _vm.datachange(props)
                                    },
                                  },
                                  model: {
                                    value: props.row[col.name],
                                    callback: function ($$v) {
                                      _vm.$set(props.row, col.name, $$v)
                                    },
                                    expression: "props.row[col.name]",
                                  },
                                })
                              : _c("span", [
                                  _vm._v(_vm._s(props.row[col.name])),
                                ]),
                          ]
                        : _vm._e(),
                      ["prtrSwcsWtQuantity", "prtrSwcsTonQuantity"].includes(
                        col.name
                      )
                        ? [
                            props.row.regulD10 > 0
                              ? _c("c-text-column", {
                                  attrs: {
                                    editable: _vm.editable,
                                    props: props,
                                    col: col,
                                  },
                                  on: {
                                    datachange: function ($event) {
                                      return _vm.datachange(props)
                                    },
                                  },
                                  model: {
                                    value: props.row[col.name],
                                    callback: function ($$v) {
                                      _vm.$set(props.row, col.name, $$v)
                                    },
                                    expression: "props.row[col.name]",
                                  },
                                })
                              : _c("span", [
                                  _vm._v(_vm._s(props.row[col.name])),
                                ]),
                          ]
                        : _vm._e(),
                      [
                        "dangerousClass",
                        "dangerousProp",
                        "dangerousName",
                        "calcuOriginal",
                        "calcuMultiple",
                      ].includes(col.name)
                        ? [
                            props.row.regulD14 > 0 && !props.row.dangerousClass
                              ? [
                                  col.name === "dangerousName"
                                    ? _c(
                                        "div",
                                        { staticClass: "merged-msg-container" },
                                        [
                                          _vm._v(
                                            "위안법 물질입니다. 허가배수 관리 메뉴에서 사업장 총 허가배수를 등록바랍니다."
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              : _c("span", [
                                  _vm._v(_vm._s(props.row[col.name])),
                                ]),
                          ]
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _c("c-btn", {
                        attrs: {
                          label: "규제 판단 기준 매뉴얼",
                          icon: "help_outline",
                          color: "info",
                        },
                        on: { btnClicked: _vm.openManual },
                      }),
                      _c("c-checkbox", {
                        attrs: {
                          isFlag: "",
                          noborder: "",
                          falseLabel: "삭제물질 포함",
                          trueLabel: "삭제물질 포함",
                          name: "delFlag",
                          addClasses: "chemComponentsCheckbox",
                        },
                        on: { input: _vm.getDetail },
                        model: {
                          value: _vm.delFlag,
                          callback: function ($$v) {
                            _vm.delFlag = $$v
                          },
                          expression: "delFlag",
                        },
                      }),
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: { label: "LBLADD", icon: "add" },
                            on: { btnClicked: _vm.addRow },
                          })
                        : _vm._e(),
                      _vm.editable && _vm.grid.data.length > 0
                        ? _c("c-btn", {
                            attrs: { label: "LBLSAVE", icon: "save" },
                            on: { btnClicked: _vm.saveSubstance },
                          })
                        : _vm._e(),
                      _vm.editable && _vm.grid.data.length > 0
                        ? _c("c-btn", {
                            attrs: { label: "LBLREMOVE", icon: "remove" },
                            on: { btnClicked: _vm.removeRow },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(
            "c-table",
            {
              ref: "innertable",
              staticClass: "topcolor-orange",
              attrs: {
                tableId: "innertable",
                title: "구성성분별 규제사항",
                columns: _vm.grid2.columns,
                data: _vm.grid2.data,
                columnSetting: false,
                filtering: false,
                usePaging: false,
                hideBottom: true,
                editable: false,
                gridHeight: _vm.innertableHeight,
              },
            },
            [
              _c(
                "template",
                { slot: "suffixTitle" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm._v("       "),
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: {
                              label: "규제항목 기준값 조회",
                              icon: "history",
                            },
                            on: { btnClicked: _vm.openChemQuantity },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
      _c("ChemUpdateManualDialog", {
        model: {
          value: _vm.manualVisible,
          callback: function ($$v) {
            _vm.manualVisible = $$v
          },
          expression: "manualVisible",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }